import { useLayoutEffect } from "react";
import { imageClass } from "view/components/RichTextEditor/hooks/useImagesEdit";
import { getImageScale } from "tools/richText/getImageScale";

/**
 * Applies each rich-text image's `scale` param as an inline width.
 *
 * Runs once on mount by default. Pass `trigger` when the HTML arrives after
 * mount (e.g. the custom email preview, which receives it over `postMessage`):
 * the pass re-runs whenever it changes.
 */
export const useRichTextImages = (trigger?: unknown) => {
  useLayoutEffect(() => {
    const allImages = document.querySelectorAll<HTMLImageElement>(
      `img.${imageClass}`
    );
    if (!allImages.length) {
      return;
    }
    allImages.forEach((image) => {
      const scale = getImageScale(image.src);
      if (scale) {
        image.style.width = `${scale}%`;
      }
    });
  }, [trigger]);
};
